<div class="modal-header bg-dark">
  <h4 class="modal-title" translate>Über ACmobile</h4>
  <button
    type="button"
    class="btn-close btn-close-white"
    aria-label="Close"
    (click)="modal.dismiss()"
    tabindex="-1"></button>
</div>
<div class="modal-body">
  @if (acmobileAbout) {
    <div class="multiline" [innerHTML]="acmobileAbout | i18nText"></div>
  }
  <div
    class="mt-4 clickable"
    (click)="versionInfoCollapsed = !versionInfoCollapsed"
    aria-expanded="!versionInfoCollapsed"
    aria-controls="collapse-version-info">
    <span translate>Version-Info</span>
    <button class="btn btn-link btn-details-toggle">
      <i
        class="fas"
        [ngClass]="{
          'fa-chevron-circle-down': versionInfoCollapsed,
          'fa-chevron-circle-up': !versionInfoCollapsed,
        }"></i>
    </button>
  </div>
  <div [ngbCollapse]="versionInfoCollapsed" id="collapse-version-info">
    <div class="small">
      <span translate>ACmobile-Client.Version:</span>&nbsp;<span>{{ acmobileClientVersion }}</span>
    </div>
    <div class="small">
      <span translate>ACmobile-Services.Version:</span>&nbsp;
      @if (acmobileServicesVersion) {
        <span>{{ acmobileServicesVersion }}</span>
      }
      @if (!acmobileServicesVersion) {
        <span translate>Nicht verfügbar</span>
      }
    </div>
    <div class="small">
      <span translate>Client-Config.Version:</span>&nbsp;
      @if (clientConfigVersion) {
        <span>{{ clientConfigVersion }}</span>
      }
      @if (!clientConfigVersion) {
        <span translate>Nicht verfügbar</span>
      }
    </div>
    <div class="small">
      <span translate>Inspection-Type-Config.Version:</span>&nbsp;
      @if (inspectionTypeConfigVersion) {
        <span>{{ inspectionTypeConfigVersion }}</span>
      }
      @if (!inspectionTypeConfigVersion) {
        <span translate>Nicht verfügbar</span>
      }
    </div>
    <div class="small">
      <span translate>Category-Config.Version:</span>&nbsp;
      @if (categoryConfigVersion) {
        <span>{{ categoryConfigVersion }}</span>
      }
      @if (!categoryConfigVersion) {
        <span translate>Nicht verfügbar</span>
      }
    </div>
    <div class="small">
      <span translate>Point-Config.Version:</span>&nbsp;
      @if (pointConfigVersion) {
        <span>{{ pointConfigVersion }}</span>
      }
      @if (!pointConfigVersion) {
        <span translate>Nicht verfügbar</span>
      }
    </div>
    <div class="small">
      <span translate>Point-To-Category-Mapping.Version:</span>&nbsp;
      @if (pointToCategoryMappingConfigVersion) {
        <span>{{ pointToCategoryMappingConfigVersion }}</span>
      }
      @if (!pointToCategoryMappingConfigVersion) {
        <span translate>Nicht verfügbar</span>
      }
    </div>
    <div class="small">
      <span translate>Point-To-Point-Group-Mapping.Version:</span>&nbsp;
      @if (pointToPointGroupMappingConfigVersion) {
        <span>{{ pointToPointGroupMappingConfigVersion }}</span>
      }
      @if (!pointToPointGroupMappingConfigVersion) {
        <span translate>Nicht verfügbar</span>
      }
    </div>
  </div>
</div>
<div class="modal-footer">
  <div>
    <button
      type="button"
      class="btn btn-outline-primary"
      (click)="modal.dismiss()"
      appAutofocus
      translate>
      Schliessen
    </button>
  </div>
</div>
